export const paths = {
  home: '/',
  world: '/world',
  nfts: '/nfts',
  game: '/game',
  faq: '/faq',
  privacy: '/privacy',
  terms: '/terms'
};
